import { useCallback } from 'react';
import { isSameYear } from 'date-fns';
import { useFormatter, useNow, useTranslations } from 'next-intl';

export const useFormatTimestamp = () => {
  const tCommon = useTranslations('common');
  const format = useFormatter();
  const nowWithUpdates = useNow({ updateInterval: 1000 * 60 });
  const now = useNow();

  const formatTimestampFromNow = useCallback(
    (timestamp: string) => {
      const date = new Date(timestamp);
      if (Number.isNaN(date.getTime())) {
        return '';
      }

      const diffSeconds = Math.abs((nowWithUpdates.getTime() - date.getTime()) / 1000);

      if (diffSeconds < 60) {
        return tCommon('justNow');
      }

      return format.relativeTime(date, nowWithUpdates);
    },
    [format, nowWithUpdates, tCommon],
  );

  const formatTimestampDateAndTime = useCallback(
    (timestamp: string) => {
      const parsed = new Date(timestamp);

      return format.dateTime(parsed, {
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ...(isSameYear(parsed, now) ? {} : { year: 'numeric' }),
      });
    },
    [format, now],
  );

  return { formatTimestampFromNow, formatTimestampDateAndTime };
};
